import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AsyncJobMonitor } from '../components/jobs/AsyncJobMonitor';

export const AsyncJobMonitorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const jobId = searchParams.get('job_id');
  const storeId = searchParams.get('store_id');
  const storeName = searchParams.get('store_name');
  const productCount = searchParams.get('product_count');
  
  if (!jobId) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No job ID provided for monitoring</p>
        <button 
          onClick={() => navigate('/jobs')}
          className="mt-4 px-4 py-2 bg-primary text-white rounded"
        >
          Back to Jobs
        </button>
      </div>
    );
  }

  const handleJobCompleted = (batchId: string) => {
    navigate(`/jobs/monitor?batch_id=${batchId}`);
  };

  const handleBack = () => {
    navigate('/jobs');
  };

  const jobMetadata = storeId && storeName && productCount ? {
    storeId,
    storeName,
    productCount: parseInt(productCount)
  } : undefined;

  return (
    <AsyncJobMonitor
      jobId={jobId}
      onJobCompleted={handleJobCompleted}
      onBack={handleBack}
      jobMetadata={jobMetadata}
    />
  );
};

export default AsyncJobMonitorPage;